module.exports = __webpack_public_path__ + "static/img/2_1_1.428a6f62.jpg";